export const getAdminBaseUrl = (): string =>
  import.meta.env.VITE_ADMIN_BASE_URL || 'http://localhost/admin';

export const getAdminClientId = (): string => {
  const value = import.meta.env.VITE_ADMIN_CLIENT_ID;
  if (!value) throw new Error('VITE_ADMIN_CLIENT_ID is not configured');
  return value;
};

export const API_CONFIG = {
  adminBaseURL: getAdminBaseUrl(),
  clientId: getAdminClientId(),
  timeout: 30_000,
  endpoints: {
    auth: {
      login: '/auth/login',
      logout: '/auth/logout',
      refresh: '/auth/refresh',
      me: '/auth/me',
      token: '/auth/token',
    },
  },
} as const;
